import { render } from "./pool.vue?vue&type=template&id=5e20c68c"
import script from "./pool.vue?vue&type=script&lang=js"
export * from "./pool.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\pool_11_24\\pool_11_24\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__